// Loader.tsx
import React from 'react';
import { Box, CircularProgress, Backdrop } from '@mui/material';

interface LoaderProps {
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ fullScreen = true }) => {
  return (
    <Backdrop
      open={true}
      sx={{
        color: '#fff',
        zIndex: fullScreen ? 9999 : 20,
        position: fullScreen ? 'fixed' : 'absolute',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: '#0070f3',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(0,112,243,0.2) 0%, rgba(0,112,243,0) 70%)',
            position: 'absolute',
            animation: 'pulse 1.5s ease-in-out infinite',
            '@keyframes pulse': {
              '0%, 100%': {
                transform: 'scale(1)',
                opacity: 0.8,
              },
              '50%': {
                transform: 'scale(1.3)',
                opacity: 0.4,
              },
            },
          }}
        />
      </Box>
    </Backdrop>
  );
};

export default Loader;
